import React, { useEffect, useRef } from "react";
import "./movieDetails.css";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  MovieDetailStyle,
  MovieDetailSecondPgStyle,
} from "../style/componentsStyle";
import {
  fetchClients,
  getJobCard,
  getSelectedcard,
  roleSelector,
  UpdateJobCard,
} from "features/jobinv/JobCardSlice";
import { ROLES, STAGES } from "components/common/Constants";
import { Form, Input, Button, Space, Radio, Row, Col, Modal, Select, message, Upload, Checkbox, Card, Tooltip, Empty, Tag, Spin } from "antd";
import { FilePdfOutlined, UploadOutlined, DeleteOutlined, UserOutlined, DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import {
  getFormalName,
  getNextStage,
  getPreviousStage,
} from "components/services";
import { useReactToPrint } from "react-to-print";
import ImageViewer from "components/ImageViewer";
import Loader from "components/common/Loader";
import {
  useFetchJobcardsQuery,
  useGetClientsQuery,
  useGetJobcardQuery,
  useUpdateJobcardMutation,
  useUploadJobcardInvoicesMutation,
  useGetJobcardInvoicesQuery,
  useDeleteJobcardInvoiceMutation,
  useFetchDispatchDetailsQuery,
  useUploadJobcardImagesMutation,
  useUpdateJobcardImagesMutation,
  useDeleteJobcardImageMutation,
  useFetchColorsQuery,
} from "features/store";
import { allApi } from "features/jobinv/AllApi";
import SelectType from "components/jobcard/SelectType";
import { url as API_BASE_URL } from "components/common/api";
import { useGetJobcardImageDetailQuery } from "features/store";
import { getImage, getImageFromDetail, getImageUploader } from "helper";
import { downloadS3File } from "utils/downloadFile";
import { formatImageCreatedAt, formatJobcardCreatedAt } from "utils/timezoneUtils";

const courierModeOptions = ["Self Pickup", "Dunzo", "Porter", "Courier", "Trasnport"];

// Payment status options
const PAYMENT_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'refunded', label: 'Refunded' },
  { value: 'partially_paid', label: 'Partially Paid' },
  { value: 'on_hold', label: 'On Hold' },
  { value: 'credit', label: 'Credit' },
];

// Helper function to get status color
const getStatusColor = (status) => {
  const statusColors = {
    'pending': { border: '#FFA500', background: '#FFF8E1' }, // Orange
    'in_progress': { border: '#FFA500', background: '#FFF8E1' }, // Orange
    'completed': { border: '#52c41a', background: '#F6FFED' }, // Green
    'failed': { border: '#dc3545', background: '#FFF1F0' }, // Red
    'cancelled': { border: '#dc3545', background: '#FFF1F0' }, // Red
    'refunded': { border: '#722ed1', background: '#F9F0FF' }, // Purple
    'partially_paid': { border: '#1890ff', background: '#E6F7FF' }, // Blue
    'on_hold': { border: '#faad14', background: '#FFFBE6' }, // Yellow
    'credit': { border: '#722ed1', background: '#F9F0FF' }, // Purple tone for credit
    'expired': { border: '#8c8c8c', background: '#FAFAFA' }, // Gray
  };
  return statusColors[status] || { border: '#d9d9d9', background: '#FAFAFA' };
};

// Helper function to format status text
const formatStatus = (status) => {
  if (!status) return "Pending";
  return status
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const PrintStyles = () => (
  <style>
    {`
      @media print {
        .printable-content {
          padding-top: 1rem !important;
        }
        /* Hide any blocks explicitly marked as print-hidden */
        .print-hide { display: none !important; }
      }
    `}
  </style>
);

// Hover styles for interactive image cards in Movie Details
const HoverStyles = () => (
  <style>
    {`
      .md-img-card { position: relative; border-radius: 18px; overflow: hidden; box-shadow: 0 6px 16px rgba(0,0,0,0.15); height: 180px; background: #f0f0f0; cursor: zoom-in; }
      .md-img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform 220ms ease, filter 220ms ease; }
      .md-overlay { position: absolute; inset: 0; background: linear-gradient(to bottom, rgba(0,0,0,0.0), rgba(0,0,0,0.35)); opacity: 0; transition: opacity 220ms ease; }
      .md-img-card:hover .md-img { transform: scale(1.045); filter: saturate(1.02); }
      .md-img-card:hover .md-overlay { opacity: 1; }
      .md-download { transition: transform 220ms ease, background 220ms ease, color 220ms ease; }
      .md-img-card:hover .md-download { transform: translateX(-50%) translateY(-2px); background: #111; color: #fff; }
      .image-cards-container { 
        display: flex; 
        flex-wrap: wrap; 
        gap: 16px; 
        align-items: flex-start; 
      }
      @media (max-width: 768px) {
        .image-cards-container { flex-direction: column; }
        .image-cards-container > div { width: 100% !important; }
      }
    `}
  </style>
);


const MovieDetail = () => {
  const componentRef = useRef();
  const { id } = useParams();
  const dispatch = useDispatch();
  const handlePrint = useReactToPrint({
    copyStyles: true,
    content: () => componentRef.current,
    documentTitle: "emp-data",
    onAfterPrint: () => alert("Print success"),
  });
  const { data } = useGetJobcardQuery(id);
  const { cards } = useFetchJobcardsQuery();
  // Colors hook for resolving eyelet color IDs to names
  // (exported from features/store)

  const {
    data: dispatchDetailsData,
    isFetching: isDispatchDetailsLoading,
  } = useFetchDispatchDetailsQuery(id, {
    skip: !id,
  });
  const [updateJobcard, updateResponseInfo] = useUpdateJobcardMutation();
  const [addressType, setAddressType] = React.useState('shipping');

  console.log("updateJobcard: ", updateJobcard);

  const { isLoading: isUpdating, isSuccess } = updateResponseInfo;
  console.log("isSuccess: ", isSuccess);
  console.log("data: ", data);
  // const clients = useSelector((state) => state.JobCard.clients);
  const { data: clients, isLoading: loading } = useGetClientsQuery();
  const [form] = Form.useForm();
  const [courierMode, setCourierMode] = React.useState(data?.courier_mode || "");
  const [quantity, setQuantity] = React.useState(data?.quantity || "");
  const [courierName, setCourierName] = React.useState(data?.courier_name || "");
  const [cartonBoxes, setCartonBoxes] = React.useState({});
  const [selectedCartonSizes, setSelectedCartonSizes] = React.useState([]);
  const [packingNote, setPackingNote] = React.useState(data?.packing_note || "");

  // console.log("client",clientss)

  // const data = useSelector(getSelectedcard);
  const role = useSelector(roleSelector);
  const navigate = useNavigate();
  const [uploadFiles, setUploadFiles] = React.useState([]);
  const [uploadJobcardInvoices, uploadInfo] = useUploadJobcardInvoicesMutation();
  const { data: invoicesData, refetch: refetchInvoices } = useGetJobcardInvoicesQuery(id, { skip: !id });
  const [deleteJobcardInvoice, deleteInfo] = useDeleteJobcardInvoiceMutation();
  const [previewInvoice, setPreviewInvoice] = React.useState(null);
  const [dispatchPreview, setDispatchPreview] = React.useState(null);
  const dispatchDetails = dispatchDetailsData || [];

  // State variables for embroidary upload
  const [embroidaryFilesBySide, setEmbroidaryFilesBySide] = React.useState({});
  const [embroidaryTitlesBySide, setEmbroidaryTitlesBySide] = React.useState({});
  const [embroidaryDescriptionsBySide, setEmbroidaryDescriptionsBySide] = React.useState({});
  const [embroidaryPreviewsBySide, setEmbroidaryPreviewsBySide] = React.useState({});
  // Fetch colors to resolve eyelet color IDs to names
  const { data: colorsList } = useFetchColorsQuery({ skip: data?.style });
  const colorNameById = React.useMemo(() => {
    const map = {};
    const arr = Array.isArray(colorsList) ? colorsList : [];
    arr.forEach((it) => {
      if (it?.id != null) map[it.id] = it.color;
    });
    return map;
  }, [colorsList]);
  const resolveEyeletColor = (val) => {
    if (val == null || val === '') return '';
    const id = Number(val);
    if (!isNaN(id) && colorNameById[id]) return colorNameById[id];
    return String(val);
  };

  // Upload mutations for embroidary images
  const [uploadJobcardImages, uploadImagesInfo] = useUploadJobcardImagesMutation();
  const [updateJobcardImages, updateImagesInfo] = useUpdateJobcardImagesMutation();
  const [deleteJobcardImage] = useDeleteJobcardImageMutation();

  const formatDateTimeDisplay = (value, options = {}) => {
    if (!value) return "—";
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        ...options,
      });
    }
    return value;
  };

  const formatDateDisplay = (value) =>
    formatDateTimeDisplay(value, { hour: undefined, minute: undefined });

  const formatTimeDisplay = (value) => {
    if (!value) return "—";
    if (value.includes(":")) {
      const [hours, minutes] = value.split(":");
      return `${hours?.padStart(2, "0")}:${minutes?.padStart(2, "0")}`;
    }
    return value;
  };

  const current_stage = data?.current_stage;
  const canShowPackingSection =
    (role === ROLES.PACKING || role === ROLES.ADMIN) &&
    current_stage === STAGES.PACKING;
  const contentPaddingTop = React.useMemo(() => {
    if (role === ROLES.PACKING) {
      return canShowPackingSection ? "48rem" : "5rem";
    }
    if (role === ROLES.ADMIN || role === ROLES.DESIGN) {
      return canShowPackingSection ? "50rem" : "5rem";
    }
    if (role === ROLES.ACCOUNT) {
      return "12rem";
    }
    return "5rem";
  }, [role, canShowPackingSection]);

  console.log("job card: ", data);

  const [client, setClient] = React.useState();
  const storedUser = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch (error) {
      return {};
    }
  }, []);
  const activeRole = role || storedUser?.roll || storedUser?.role;
  const isViewer = activeRole === ROLES.VIEWER;
  const [showDigitizerValidationModal, setShowDigitizerValidationModal] = React.useState(false);
  const [showRejectConfirmModal, setShowRejectConfirmModal] = React.useState(false);

  // Removed local "work done" checkbox state and syncing effect.

  const withBase = (src) => (src?.startsWith("http") ? src : `${API_BASE_URL}${src?.startsWith("/") ? "" : "/"}${src || ""}`);

  const canSeeImages = [ROLES.ADMIN, ROLES.DESIGN, ROLES.EMBROIDARY].includes(role);

  // Use specific image detail API when viewing details - do not call /api/degitizer-jobcards/
  const { data: jobcardImageDetail, refetch: refetchJobcardImageDetail } = useGetJobcardImageDetailQuery(id, {
    skip: !id,
  });

  const embImages = React.useMemo(() => {
    try {
      if (jobcardImageDetail) {
        // Use the direct API response - images array
        return jobcardImageDetail?.images || [];
      }
      return [];
    } catch (e) {
      return [];
    }
  }, [jobcardImageDetail]);

  const downloadImage = async (url, suggestedName) => {
    try {
      await downloadS3File(url, suggestedName);
    } catch (e) {
      console.error("Download failed:", e);
    }
  };

  // Resolve side-wise technique(s) from API response without altering logic
  const getTechniqueText = (label) => {
    try {
      const src = data?.techniques;
      if (!src || typeof src !== "object") return "";
      const aliases = {
        Front: ["front", "Front"],
        Top: ["cap_top", "Top", "top"],
        "Brim Top": ["brim_top", "Brim Top", "visor_top", "top"],
        "Brim Under": ["brim_under", "Brim Under", "under", "visor_under"],
        "Cross Band": ["cross_band", "Cross Band"],
        Middle: ["middle", "Middle"],
        Back: ["back", "Back"],
        Under: ["under", "Under"],
      };
      const keys = aliases[label] || [String(label || "").toLowerCase()];
      let val = null;
      for (const k of keys) {
        if (Object.prototype.hasOwnProperty.call(src, k) && src[k] != null) {
          val = src[k];
          break;
        }
      }
      if (val == null) return "";
      const items = Array.isArray(val)
        ? val.filter(Boolean)
        : typeof val === "string"
          ? [val]
          : Object.values(val || {}).filter(Boolean);
      if (!items.length) return "";
      return ", " + items.join(", ");
    } catch {
      return "";
    }
  };

  // Get sides that have images based on jobcard flags
  const getSidesWithImages = () => {
    if (!data) return [];

    const sideMeta = [
      { label: "Front", key: "is_front" },
      { label: "Right Middle", key: "is_right_middle" },
      { label: "Left Middle", key: "is_left_middle" },
      { label: "Back", key: "is_back" },
      { label: "Velcro", key: "is_velcro" },
      { label: "Visor", key: "is_visor" },
    ];

    return sideMeta.filter(({ key }) => data[key] === true);
  };

  // Handle file change for embroidary upload
  const handleEmbroidaryFileChange = (side, file) => {
    if (!file) return false;
    setEmbroidaryFilesBySide((prev) => ({ ...prev, [side]: file }));

    if (file.type?.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        setEmbroidaryPreviewsBySide((prev) => ({ ...prev, [side]: reader.result }));
      };
      reader.readAsDataURL(file);
    } else {
      setEmbroidaryPreviewsBySide((prev) => {
        const next = { ...prev };
        delete next[side];
        return next;
      });
    }
    return false; // prevent auto upload
  };

  // Handle embroidary image upload
  const handleEmbroidaryUpload = async () => {
    if (!data || !id) return;

    const sidesWithImages = getSidesWithImages();
    const selectedSides = sidesWithImages.filter(({ label }) => embroidaryFilesBySide[label]);

    if (selectedSides.length === 0) {
      message.warning("Please select at least one side to upload");
      return;
    }

    // Validate title and description are mandatory
    const missingFields = [];
    selectedSides.forEach(({ label }) => {
      if (!embroidaryTitlesBySide[label] || embroidaryTitlesBySide[label].trim() === "") {
        missingFields.push(`${label} - Title`);
      }
    });

    if (missingFields.length > 0) {
      message.error(`Please fill all required fields: ${missingFields.join(", ")}`);
      return;
    }

    // Check for existing embroidary images
    const existingEmbroidaryImages = {};
    (embImages || []).forEach((img) => {
      if (img && img.side && img.is_embroidary_image) {
        existingEmbroidaryImages[img.side] = img;
      }
    });

    // Remove stale embroidery rejections for sides not selected in this cycle
    const sidesToRemove = Object.keys(existingEmbroidaryImages).filter(
      (side) => !selectedSides.some((s) => s.label === side)
    );
    if (sidesToRemove.length) {
      try {
        await Promise.all(
          sidesToRemove.map((side) =>
            deleteJobcardImage(existingEmbroidaryImages[side]?.id).unwrap()
          )
        );
      } catch (cleanupError) {
        message.error("Failed to clear old embroidery issues. Please retry.");
        return;
      }
    }

    const filesToUpdate = [];
    const filesToCreate = [];

    selectedSides.forEach(({ label }) => {
      if (existingEmbroidaryImages[label]?.id) {
        filesToUpdate.push(label);
      } else {
        filesToCreate.push(label);
      }
    });

    const storedUser = JSON.parse(localStorage.getItem("user") || "null");
    const username = storedUser?.username || storedUser?.email || "unknown";

    try {
      // Handle updates
      if (filesToUpdate.length > 0) {
        const updateMetadata = [];
        const updateFiles = [];

        filesToUpdate.forEach((side) => {
          const file = embroidaryFilesBySide[side];
          const originalName = file?.name || "";
          const dotIndex = originalName.lastIndexOf(".");
          const ext = dotIndex > -1 ? originalName.slice(dotIndex) : "";
          const safeSide = side.replace(/\s+/g, "_");
          const filename = `embroidary_${safeSide}${ext}`;
          const renamed = new File([file], filename, { type: file.type, lastModified: file.lastModified });

          const existingImage = existingEmbroidaryImages[side];
          updateMetadata.push({
            id: existingImage.id,
            filename,
            side,
            created_by: username,
            title: embroidaryTitlesBySide[side],
            description: embroidaryDescriptionsBySide[side],
          });
          updateFiles.push(renamed);
        });

        await updateJobcardImages({
          metadata: updateMetadata,
          files: updateFiles,
        }).unwrap();
      }

      // Handle new uploads
      if (filesToCreate.length > 0) {
        const createMetadata = [];
        const createFiles = [];

        filesToCreate.forEach((side) => {
          const file = embroidaryFilesBySide[side];
          const originalName = file?.name || "";
          const dotIndex = originalName.lastIndexOf(".");
          const ext = dotIndex > -1 ? originalName.slice(dotIndex) : "";
          const safeSide = side.replace(/\s+/g, "_");
          const filename = `embroidary_${safeSide}${ext}`;
          // Create a new File with the exact filename to ensure backend can match it
          const renamed = new File([file], filename, { type: file.type, lastModified: file.lastModified });

          // Verify the file name is set correctly
          if (renamed.name !== filename) {
            console.warn(`File name mismatch: expected ${filename}, got ${renamed.name}`);
          }

          createMetadata.push({
            filename,
            side,
            title: embroidaryTitlesBySide[side],
            description: embroidaryDescriptionsBySide[side],
          });
          createFiles.push(renamed);
        });

        // Debug: Log what we're sending
        console.log('Uploading embroidary images:', {
          metadataCount: createMetadata.length,
          filesCount: createFiles.length,
          metadata: createMetadata.map(m => ({ filename: m.filename, side: m.side })),
          fileNames: createFiles.map(f => f.name)
        });

        await uploadJobcardImages({
          job_card_id: id,
          is_embroidary_image: true,
          metadata: createMetadata,
          files: createFiles,
        }).unwrap();
      }

      // After successful image upload, update jobcard to reject it
      // Keep stage unset so only digitizer sees it, but mark digitizer stage flag
      await updateJobcard({
        id: id,
        current_stage: null,
        is_degitizer_stage: true,
      }).unwrap();

      message.success("Jobcard rejected and sent back to digitizer");
      setEmbroidaryFilesBySide({});
      setEmbroidaryTitlesBySide({});
      setEmbroidaryDescriptionsBySide({});
      setEmbroidaryPreviewsBySide({});

      // Refetch data and navigate back
      refetchJobcardImageDetail();
      // Navigate back to jobcard list after a short delay
      setTimeout(() => {
        navigate("/jobcard");
      }, 1500);
    } catch (e) {
      message.error("Rejection failed: " + (e?.data?.detail || e.message || "Unknown error"));
    }
  };

  const showRate = () =>
    [ROLES.ADMIN, ROLES.DESIGN, ROLES.ACCOUNT].includes(role);

  const showCordinator = () => showRate();

  useEffect(() => {
    if (data && clients?.length > 0) {
      const client = clients.find((client) => client.id === data.client);
      if (
        role === ROLES.ADMIN ||
        role === ROLES.DESIGN ||
        role === ROLES.ACCOUNT ||
        role === ROLES.CUTTING ||
        role === ROLES.SECONDARY_PROCESS ||
        role === ROLES.EMBROIDARY ||
        role === ROLES.PRODUCTION
      ) {
        setClient(client);
      }
    }
  }, [clients, data]);

  useEffect(() => {
    if (data && clients?.length > 0) {
      const client = clients.find((c) => c.id === data.client);
      setClient(client);
      setCourierMode(data.courier_mode || "");
      setQuantity(data.quantity || "");
      setCourierName(data.courier_name || "");
      const isBilling = client?.billing_address === data.shipping_address;
      setAddressType(isBilling ? 'billing' : 'shipping');
      form.setFieldsValue({
        courier_mode: data.courier_mode || "",
        quantity: data.quantity || "",
        shipping_address: data.shipping_address || "",
        courier_name: data.courier_name || "",
      });

      // Initialize carton boxes from data
      if (data.carton_boxes && Array.isArray(data.carton_boxes)) {
        const boxesMap = {};
        const sizes = [];
        data.carton_boxes.forEach(box => {
          boxesMap[box.size] = box.quantity;
          sizes.push(box.size);
        });
        setCartonBoxes(boxesMap);
        setSelectedCartonSizes(sizes);
      }

      // Initialize packing note
      setPackingNote(data.packing_note || "");
    }
  }, [data, clients, form]);

  // Clear courier_name when courier mode changes away from 'Courier'
  useEffect(() => {
    if (courierMode !== 'Courier') {
      setCourierName("");
      form.setFieldsValue({ courier_name: "" });
    }
  }, [courierMode, form]);

  useEffect(() => {
    if (role === ROLES.CUTTING && data?.current_stage !== STAGES.CUTTING)
      navigate("/");

    if (role === ROLES.PRODUCTION && data?.current_stage !== STAGES.PRODUCTION)
      navigate("/");

    if (role === ROLES.ACCOUNT && data?.current_stage !== STAGES.ACCOUNT)
      navigate("/");
    if (
      role === ROLES.SECONDARY_PROCESS &&
      data?.current_stage !== STAGES.SECONDARY_PROCESS
    )
      navigate("/");
  }, [role, cards]);

  return data ? (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>

        <PrintStyles />
        <HoverStyles />
        <div
          ref={componentRef}
          style={{ width: "100%", height: window.innerHeight, position: "relative" }}
        >
          {/* Created Date - Top right corner of print box */}
          {data.created_at && (
            <div
              style={{
                fontSize: "15px",
                color: "rgb(102, 102, 102)",
                position: "absolute",
                top: "0px",
                right: "175px",
                paddingTop: contentPaddingTop,
                zIndex: 10,
              }}
            >
              Created Date: {formatJobcardCreatedAt(data.created_at)}
            </div>
          )}
          {/* Removed Work Done checkbox UI as per requirement */}
          <div
            style={{
              paddingTop: contentPaddingTop,
              paddingRight: "24px",
              paddingLeft: "24px",
              overflowX: "hidden"
            }}
            className="printable-content"
          >

            <MovieDetailStyle>
              <div>
                <section className="main_jobcard_section">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <h1>Job Card</h1>
                    <p className="created" style={{ marginBottom: "10px" }}>
                      Created By: <span>{data.Created_by}</span>
                    </p>
                  </div>
                  <div className="main-content-conatiner">

                    <div className="main_content">
                      <div className="first_section">
                        <ul>
                          <li>
                            Date: <span><b>{data.date}</b></span>
                          </li>
                          {client && (
                            <li style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              Party Name:
                              <span style={{ color: "red", fontSize: "30px" }}><b>{client?.company_name}</b> </span>
                            </li>
                          )}
                          <li>
                            Address.: <span><b> {data?.shipping_address}</b></span>
                          </li>
                          {client && (
                            <li>
                              GST NO.: <span><b> {client?.GST_NO}</b></span>
                            </li>
                          )}

                          <li>
                            Job Coordinator:
                            <span><b>{data.job_coordinator}</b></span>
                          </li>
                          <li>
                            Quantity:
                            <span><b>{data.quantity} pieces</b></span>
                          </li>
                        </ul>
                      </div>

                      <div className="first_section">
                        <ul>
                          <li style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            Jobcard No.: <span style={{ color: "red", fontSize: "30px" }}><b>{data?.serial_number ?? data?.id}</b></span>
                          </li>
                          <li>
                            Delivery Date:
                            <span><b>{data.deliver_date}</b></span>
                          </li>
                          <li>
                            Style: <span><b>{data.style}</b></span>
                          </li>
                          {client && (
                            <li>
                              Mob No.: <span><b>{client?.phone}</b></span>
                            </li>
                          )}
                          {showRate() && (
                            <>
                              <li className="print-hide">
                                Rate: <span><b>{data.rate}</b></span>
                              </li>
                              {data.billing_type ? (
                                <li>
                                  Billing Type: <span><b>{data.billing_type}</b></span>
                                </li>
                              ) : null}
                            </>
                          )}
                          <li>
                            Size : <span><b>{data.size}</b></span>
                          </li>
                          {isViewer && (
                            <li>
                              Rate: <span><b>{data.rate}</b></span>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <h1 className="style_info">Style Information</h1>
                  <div className="styleinfo">
                    <div className="styleinfoone one">
                      <h3>Main Fabric and Color</h3>
                      <div className="style styleinfo-box">
                        {(data.style === "BUCKET HAT" || data.style === "REVERSIBLE BUCKET HAT") ? (
                          <>
                            <p>
                              Front: <b>{data.main_fabric_Front_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Front_color}</b>{getTechniqueText("Front")}
                            </p>
                            <p>
                              Top: <b>{data.main_fabric_Top_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Top_color}</b>{getTechniqueText("Top")}
                            </p>
                            <p>
                              Brim Top: <b>{data.main_fabric_Brim_Top_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Brim_Top_color}</b>{getTechniqueText("Brim Top")}
                            </p>
                            <p>
                              Brim Under: <b>{data.main_fabric_Brim_Under_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Brim_Under_color}</b>{getTechniqueText("Brim Under")}
                            </p>
                            <p>
                              Cross Band: <b>{data.main_fabric_Cross_Band_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Cross_Band_color}</b>{getTechniqueText("Cross Band")}
                            </p>
                          </>
                        ) : data.style === "UMPIRE HAT" ? (
                          <>
                            <p>
                              Front: <b>{data.main_fabric_Front_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Front_color}</b>{getTechniqueText("Front")}
                            </p>
                            <p>
                              Top: <b>{data.main_fabric_Top_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Top_color}</b>{getTechniqueText("Top")}
                            </p>
                            <p>
                              Brim Top: <b>{data.main_fabric_Brim_Top_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Brim_Top_color}</b>{getTechniqueText("Brim Top")}
                            </p>
                            <p>
                              Brim Under: <b>{data.main_fabric_Brim_Under_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Brim_Under_color}</b>{getTechniqueText("Brim Under")}
                            </p>
                          </>
                        ) : (
                          <>
                            <p>
                              Front: <b>{data.main_fabric_Front_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Front_color}</b>{getTechniqueText("Front")}
                            </p>
                            <p>
                              Middle: <b>{data.main_fabric_Middle_type}</b>,
                              <b style={{ color: "red" }}> {data.main_fabric_Middle_color}</b>{getTechniqueText("Middle")}
                            </p>
                            <p>
                              Back: <b>{data.main_fabric_Back_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Back_color}</b>{getTechniqueText("Back")}
                            </p>
                            <p>
                              Top: <b>{data.main_fabric_Top_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Top_color}</b>{getTechniqueText("Top")}
                            </p>
                            <p>
                              Under: <b>{data.main_fabric_Under_type}</b>,
                              <b style={{ color: "red" }}>{data.main_fabric_Under_color}</b>{getTechniqueText("Under")}
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="styleinfoone ">
                      <h3>Visor Type</h3>
                      <div className="style styleinfo-box">
                        <p><b>{data.visior_type}</b></p>
                      </div>
                    </div>
                    <div className="styleinfoone ">
                      <h3>PIPING Type & Color</h3>
                      <div className="style styleinfo-box">
                        <p><b>{data.piping_type},</b></p>
                        <p><b>{data.piping_color}</b></p>
                      </div>
                    </div>
                  </div>

                  <div className="firstcontent">
                    <div className="thirdsection">
                      <ul>
                        <li>
                          Fusing : <span><b>{data.fusing}</b></span>
                        </li>
                        <li>
                          Taper: <span><b>{data.tapper}</b></span>
                        </li>

                        <li>
                          Sweatband:
                          <span><b>{data.sweate_band_type}</b></span>
                        </li>

                        {/* {data.nonon ? (
                          <li>
                            <b>NONON:</b>
                            <span>{data.nonon}</span>
                          </li>
                        ) : null}
                        {data.full_closure_elastic ? (
                          <li>
                            <b>FULL CLOSURE ELASTIC:</b>
                            <span>{data.full_closure_elastic}</span>
                          </li>
                        ) : null}
                        {data.elastic ? (
                          <li>
                            <b>ELASTIC:</b>
                            <span>{data.elastic}</span>
                          </li>
                        ) : null} */}
                      </ul>
                      <ul>
                        <li className="elylet_data">
                          Eyelet : <span></span>
                          <ul>
                            <li><b>Front {data.eyelet_front}{(() => {
                              const eyeletOption = String(data.eyelet_front || '').toUpperCase();
                              const isColorOption = eyeletOption.includes('COLOR');
                              const hasColor = data?.eyelet_details?.front?.is_eyelet_enabled && data?.eyelet_details?.front?.color;
                              return isColorOption && hasColor ? ` (${resolveEyeletColor(data.eyelet_details.front.color)})` : "";
                            })()}</b></li>
                            <li><b>Back {data.eyelet_back}{(() => {
                              const eyeletOption = String(data.eyelet_back || '').toUpperCase();
                              const isColorOption = eyeletOption.includes('COLOR');
                              const hasColor = data?.eyelet_details?.back?.is_eyelet_enabled && data?.eyelet_details?.back?.color;
                              return isColorOption && hasColor ? ` (${resolveEyeletColor(data.eyelet_details.back.color)})` : "";
                            })()}</b></li>
                            <li><b>Middle {data.eyelet_middle}{(() => {
                              const eyeletOption = String(data.eyelet_middle || '').toUpperCase();
                              const isColorOption = eyeletOption.includes('COLOR');
                              const hasColor = data?.eyelet_details?.middle?.is_eyelet_enabled && data?.eyelet_details?.middle?.color;
                              return isColorOption && hasColor ? ` (${resolveEyeletColor(data.eyelet_details.middle.color)})` : "";
                            })()}</b></li>
                          </ul>
                        </li>
                        <li>
                          Visor Stitch:
                          <span><b>{data.visor_stitch}</b></span>
                        </li>
                        {data.button ? (
                          <li>
                            Button:
                            <span><b>{data.button}</b></span>
                          </li>
                        ) : null}
                      </ul>
                      <ul>
                        {" "}
                        {data.back_close_type ? (
                          <>
                            <li>
                              BACK CLOSER TYPE:
                              <span><b>{data.back_close_type}</b></span>
                            </li>
                            <li>
                              BACK CLOSER COLOR:
                              <span><b>{data.back_closer_color}</b></span>
                            </li>
                          </>
                        ) : null}
                        {data.snapack ? (
                          <li>
                            SNAPACK :
                            <span><b>{data.snapack}</b></span>
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  </div>
                </section>
                <section>
                  <h1 className="style_info">Embroidary Placement</h1>
                  <div className="emb">
                    <div>
                      <div className="emblabe">
                        Front: <span><b>{data.embr_Front}</b></span>
                      </div>
                      <div className="emblabe">
                        Back: <span><b>{data.embr_Back}</b></span>
                      </div>
                      <div className="emblabe">
                        Left Middle:
                        <span><b>{data.embr_Left_Middle}</b></span>
                      </div>
                      <div className="emblabe">
                        Right Middle:
                        <span> <b>{data.embr_Right_Middle}</b></span>
                      </div>
                    </div>
                    <div>
                      <div className="emblabe">
                        Visor:
                        <span><b>{data.embr_Visor}</b></span>
                      </div>
                      <div className="emblabe">
                        Visor Square:
                        <span><b>{data.embr_Visor_Square}</b></span>
                      </div>
                      <div className="emblabe">
                        Velcro:
                        <span><b>{data.embr_Velcro}</b></span>
                      </div>
                      <div className="emblabe">
                        One Side:
                        <span><b>{data.embr_One_Side_Emb}</b></span>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <div className="secondcontent">
                    <div className="special-instruction">
                      Special Instruction:
                    </div>

                    <div className="partycontent special-instruction-p">
                      <b> {data.special_instructions}</b>
                    </div>
                  </div>
                  {canShowPackingSection && data.courier_mode && (
                    <div className="secondcontent">
                      <div className="special-instruction">
                        Courier Mode:
                      </div>

                      <div className="partycontent special-instruction-p">
                        <b> {data.courier_mode}</b>
                        {data.courier_name && <span> - {data.courier_name}</span>}
                      </div>
                    </div>
                  )}
                </section>

                <section>
                  <div className="firstcontent">
                    <div className="thirdsection">
                      <ul>
                        {data.interlining ? (
                          <li>
                            INTERLINING:
                            <span><b>{data.interlining}</b></span>
                          </li>
                        ) : null}
                        {data.sizing_strip ? (
                          <li>
                            SIZING STRIP:
                            <span><b>{data.sizing_strip}</b></span>
                          </li>
                        ) : null}
                        {data?.sweat_band_holding ? (
                          <li>
                            Sweat Band Holding:
                            <span><b>{data.sweat_band_holding}</b></span>
                          </li>
                        ) : null}

                        {/* <li>
                          <b>Overlock :</b> <span>{data?.carton}</span>
                        </li> 
                        <li>
                          <b>Packing :</b> <span>{data?.carton}</span>
                        </li> 
                        <li>
                          <b>Insert :</b> <span>{data?.carton}</span>
                        </li>
                        */}
                      </ul>
                      <ul>
                        <li>
                          Carton : <span><b>{data?.carton}</b></span>
                        </li>
                        {/* <li>
                          <b>Label:</b> <span>{data.nonon}</span>
                        </li>
                   
                             <li>
                          <b>Tag:</b>
                          <span>{data.nonon}</span>
                        </li>
                             <li>
                          <b>Barcode:</b>
                          <span>{data.nonon}</span>
                        </li>
                             <li>
                          <b>Polythene Sticker:</b>
                          <span>{data.nonon}</span>
                        </li>
                             <li>
                          <b>Service:</b>
                          <span>{data.nonon}</span>
                        </li>
                    */}

                        {/* {data.nonon ? (
                          <li>
                            <b>NONON:</b>
                            <span>{data.nonon}</span>
                          </li>
                        ) : null}
                        {data.full_closure_elastic ? (
                          <li>
                            <b>FULL CLOSURE ELASTIC:</b>
                            <span>{data.full_closure_elastic}</span>
                          </li>
                        ) : null}
                        {data.elastic ? (
                          <li>
                            <b>ELASTIC:</b>
                            <span>{data.elastic}</span>
                          </li>
                        ) : null} */}
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
            </MovieDetailStyle>
          </div>
          <div style={{ margin: "10rem 0" }}></div>
          <div>
            <MovieDetailSecondPgStyle>
              <div className="ctnter">
                <section className="whole">
                  <section className="first">
                    <div>
                      <div className="single">
                        <div className="fixed">Party Name</div>
                        <div className="content">{client?.company_name}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Order Dt.</div>
                        <div className="content">{data.date}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Dispatch Date</div>
                        <div className="content">{data.deliver_date}</div>
                      </div>

                      <div className="single">
                        <div className="fixed">Quantity</div>
                        <div className="content">{data.quantity} Pieces</div>
                      </div>
                    </div>
                    <div>
                      <div className="single">
                        <div className="fixed">Fusing</div>
                        <div className="content">{data.fusing}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">taper</div>
                        <div className="content">{data.tapper}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Button</div>
                        <div className="content">{data.button}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Style</div>
                        <div className="content">{data.style}</div>
                      </div>
                    </div>

                    <div>
                      <div className="single">
                        <div className="fixed">Job Card No.</div>
                        <div className="content">{data.id}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Eyelet</div>
                        <div className="content">{(() => {
                          const eyeletOption = String(data.eyelet_front || '').toUpperCase();
                          const isColorOption = eyeletOption.includes('COLOR');
                          const hasColor = data?.eyelet_details?.front?.is_eyelet_enabled && data?.eyelet_details?.front?.color;
                          return `${data.eyelet_front || ''}${isColorOption && hasColor ? ` (${resolveEyeletColor(data.eyelet_details.front.color)})` : ''}`;
                        })()}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Sweatband</div>
                        <div className="content">{data.sweate_band_type}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Visor Stitch</div>
                        <div className="content">{data.visor_stitch}</div>
                      </div>
                      <div className="single">
                        <div className="fixed">Back Closer</div>
                        <div className="content">{data.back_close_type}</div>
                      </div>
                    </div>
                  </section>
                  <section className="second">
                    <div className="secondmain">
                      <div className="img">
                        <div className="image">
                          {(() => {
                            const imgVal = data.img1;
                            if (!imgVal) {
                              return (
                                <div style={{
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#8c8c8c',
                                  fontSize: 14,
                                  background: '#fafafa',
                                  borderRadius: 6,
                                }}>
                                  Image not provided
                                </div>
                              );
                            }
                            const isPdf = String(imgVal).toLowerCase().endsWith('.pdf');
                            return isPdf ? (
                              <FilePdfOutlined style={{ color: '#cf1322' }} />
                            ) : (
                              <img src={withBase(imgVal)} alt="Image not provided" />
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </section>
                  {canSeeImages && embImages?.length ? (
                    <div className="print-hide" style={{ margin: "16px 0" }}>
                      {(() => {
                        const designerImages = embImages.filter((img) => getImageUploader(img) === "Designer");
                        const digitizerImages = embImages.filter((img) => getImageUploader(img) === "Digitizer");

                        // Cards should auto-fit to content, no width constraints for 1-5 images

                        const renderImageCard = (img, index, total, isDigitizerCard = false) => {
                          const imageUrl = getImageFromDetail(img);
                          const lower = imageUrl ? String(imageUrl).toLowerCase() : "";
                          const isPdf = !!lower && lower.endsWith('.pdf');
                          const isImage = !!lower && /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(lower);
                          const isDigitizer = getImageUploader(img) === "Digitizer";

                          // For digitizer images in digitizer card, check if we need to show title/description
                          // If digitizer image doesn't have title/description, look for corresponding designer image
                          let displayTitle = img?.title;
                          let displayDescription = img?.description;

                          if (isDigitizerCard && isDigitizer && role === ROLES.EMBROIDARY) {
                            // If digitizer image doesn't have title or description, check designer image
                            if (!displayTitle || !displayDescription) {
                              const correspondingDesignerImg = designerImages.find(
                                (designerImg) => designerImg.side === img.side
                              );
                              if (correspondingDesignerImg) {
                                // Use designer's title if digitizer doesn't have one
                                if (!displayTitle) {
                                  displayTitle = correspondingDesignerImg?.title;
                                }
                                // Use designer's description if digitizer doesn't have one
                                if (!displayDescription) {
                                  displayDescription = correspondingDesignerImg?.description;
                                }
                              }
                            }
                          }

                          return (
                            <div key={img.id} style={{ display: "flex", flexDirection: "column" }}>
                              <div
                                className="md-img-card"
                                style={{ position: "relative" }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 10,
                                    left: 10,
                                    background: "rgba(0,0,0,0.55)",
                                    color: "#fff",
                                    fontSize: 12,
                                    padding: "4px 10px",
                                    borderRadius: 999,
                                    zIndex: 2,
                                    fontWeight: 600,
                                  }}
                                >
                                  {img.side || "Image"}
                                </div>
                                {img.created_at && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 10,
                                      right: 10,
                                      background: "rgba(0,0,0,0.6)",
                                      color: "#fff",
                                      fontSize: 9,
                                      padding: "2px 6px",
                                      borderRadius: 4,
                                      zIndex: 2,
                                      fontWeight: 400,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {formatImageCreatedAt(img.created_at)}
                                  </div>
                                )}

                                {imageUrl ? (
                                  isPdf ? (
                                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <FilePdfOutlined style={{ fontSize: 48, color: "#cf1322" }} />
                                    </div>
                                  ) : isImage ? (
                                    <img
                                      src={imageUrl}
                                      alt={img.side}
                                      className="md-img"
                                    />
                                  ) : (
                                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f7f7" }}>
                                      <span role="img" aria-label="file" style={{ fontSize: 44, lineHeight: 1 }}>🗂️</span>
                                    </div>
                                  )
                                ) : (
                                  <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f7f7" }}>
                                    <span role="img" aria-label="file" style={{ fontSize: 44, lineHeight: 1 }}>🗂️</span>
                                  </div>
                                )}

                                <div className="md-overlay" />

                                <button
                                  onClick={() => {
                                    if (!imageUrl) return;
                                    const withoutQuery = String(imageUrl).split('?')[0];
                                    const dotIndex = withoutQuery.lastIndexOf('.');
                                    const ext = dotIndex !== -1 ? withoutQuery.slice(dotIndex) : '';
                                    downloadImage(imageUrl, `${data?.serial_number || data?.id || id}_${img.side}${ext}`);
                                  }}
                                  style={{
                                    position: "absolute",
                                    bottom: 10,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    border: 0,
                                    background: "#ffffff",
                                    color: "#111",
                                    cursor: "pointer",
                                    fontSize: 16,
                                    padding: "8px 12px",
                                    borderRadius: 999,
                                    fontWeight: 600,
                                    zIndex: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                  }}
                                  className="md-download"
                                >
                                  <DownloadOutlined />
                                </button>
                              </div>

                              {/* Show title and description for digitizer images */}
                              {isDigitizer && (role === ROLES.ADMIN || role === ROLES.EMBROIDARY) && (displayTitle || displayDescription) ? (
                                <div style={{ marginTop: 8, padding: "4px 2px" }}>
                                  {displayTitle ? (
                                    <div style={{ fontWeight: 600, fontSize: 13, color: "#333" }}>
                                      {displayTitle}
                                    </div>
                                  ) : null}
                                  {displayDescription ? (
                                    <div style={{ fontSize: 12, color: "#666", whiteSpace: "pre-wrap" }}>
                                      {displayDescription}
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          );
                        };

                        const renderCard = (title, images, icon) => {
                          if (!images.length) return null;

                          // Grid columns: for 1-2 images use 2 cols, for 3-5 use actual count, for 6+ use 6
                          const gridCols = images.length >= 6 ? 6 : images.length <= 2 ? 2 : images.length;

                          return (
                            <div
                              style={{
                                background: "#fff",
                                borderRadius: 12,
                                padding: 20,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                marginBottom: 16,
                                // For 6+ images: full width, for fewer: auto-fit to content
                                width: images.length >= 6 ? "100%" : "fit-content",
                                flex: images.length >= 6 ? "1 1 100%" : "0 0 auto",
                                // No maxWidth constraint for smaller cards - let them be as narrow as needed
                              }}
                            >
                              {/* Card Header */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 10,
                                  marginBottom: 16,
                                  paddingBottom: 12,
                                  borderBottom: "2px solid #f0f0f0",
                                }}
                              >
                                {icon && (
                                  <div
                                    style={{
                                      width: 32,
                                      height: 32,
                                      borderRadius: "50%",
                                      background: title === "Designer" ? "#1890ff" : title === "Embroidary" ? "#722ed1" : "#52c41a",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#fff",
                                    }}
                                  >
                                    {icon}
                                  </div>
                                )}
                                <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: "#333" }}>
                                  {title}
                                </h2>
                              </div>

                              {/* Images Grid */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: images.length === 1
                                    ? "180px"
                                    : images.length === 2
                                      ? "repeat(2, 180px)"
                                      : images.length >= 6
                                        ? "repeat(6, 1fr)"
                                        : `repeat(${gridCols}, minmax(180px, 1fr))`,
                                  gap: 16,
                                  width: "fit-content",
                                }}
                              >
                                {images.map((img, index) => renderImageCard(img, index, images.length, title === "Digitizer"))}
                              </div>
                            </div>
                          );
                        };

                        const embroidaryImages = embImages.filter((img) => getImageUploader(img) === "Embroidary");

                        return (
                          <div className="image-cards-container">
                            {renderCard(
                              "Designer",
                              designerImages,
                              <UserOutlined style={{ fontSize: 16 }} />
                            )}
                            {renderCard(
                              "Digitizer",
                              digitizerImages,
                              <UserOutlined style={{ fontSize: 16 }} />
                            )}
                            {renderCard(
                              "Embroidary",
                              embroidaryImages,
                              <UserOutlined style={{ fontSize: 16 }} />
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  ) : null}

                  {/* Embroidary Upload Section - Only show for embroidary role when jobcard is in embroidary stage */}
                  {role === ROLES.EMBROIDARY && data?.current_stage === STAGES.EMBROIDARY && data?.is_degitizer_stage === false && (
                    <div className="print-hide" style={{ margin: "24px 0", background: "#fff", borderRadius: 12, padding: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                      <h2 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>Upload Embroidary Images</h2>
                      <Row gutter={[16, 16]}>
                        {getSidesWithImages().map(({ label }) => {
                          const selected = embroidaryFilesBySide[label];
                          const selectedPreview =
                            selected?.type?.startsWith("image/") ? embroidaryPreviewsBySide[label] : null;
                          const title = embroidaryTitlesBySide[label] || "";
                          const description = embroidaryDescriptionsBySide[label] || "";
                          const existingEmbroidary = embImages?.find(img => img.side === label && img.is_embroidary_image);
                          const existingEmbroidaryUrl = existingEmbroidary ? getImageFromDetail(existingEmbroidary) : null;
                          const existingPreviewIsImage = existingEmbroidaryUrl
                            ? /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(String(existingEmbroidaryUrl).split("?")[0])
                            : false;
                          const previewSrc = selectedPreview || (existingPreviewIsImage ? existingEmbroidaryUrl : null);
                          const previewCaption = selectedPreview
                            ? "Preview of new upload"
                            : existingPreviewIsImage
                              ? "Currently uploaded image"
                              : "";

                          return (
                            <Col span={8} key={label}>
                              <div style={{
                                border: existingEmbroidary ? "1px solid #eaeaea" : "1px dashed #bfbfbf",
                                borderRadius: 8,
                                background: existingEmbroidary ? "#fafafa" : "#fcfcfc",
                                padding: 10,
                                display: "flex",
                                flexDirection: "column",
                                gap: 8
                              }}>
                                <div style={{ fontWeight: 600, fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}>
                                  {label}
                                  {existingEmbroidary && (
                                    <Tag color="green" size="small">Uploaded</Tag>
                                  )}
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    height: 140,
                                    borderRadius: 6,
                                    background: "#f7f7f7",
                                    border: "1px solid #f0f0f0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    overflow: "hidden",
                                    position: "relative",
                                  }}
                                >
                                  {previewSrc ? (
                                    <img
                                      src={previewSrc}
                                      alt={`${label} preview`}
                                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                  ) : (
                                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                                      Uploaded image preview will appear here
                                    </span>
                                  )}
                                  {previewCaption && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        bottom: 6,
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "rgba(0,0,0,0.55)",
                                        color: "#fff",
                                        fontSize: 11,
                                        padding: "2px 8px",
                                        borderRadius: 999,
                                      }}
                                    >
                                      {previewCaption}
                                    </div>
                                  )}
                                </div>
                                <div style={{ position: "relative" }}>
                                  <Upload.Dragger
                                    beforeUpload={(file) => {
                                      handleEmbroidaryFileChange(label, file);
                                      return false;
                                    }}
                                    multiple={false}
                                    maxCount={1}
                                    showUploadList={false}
                                    style={{ width: "100%", background: "transparent", padding: 4, border: "none" }}
                                  >
                                    <div>
                                      <UploadOutlined style={{ fontSize: 20, color: selected ? "#52c41a" : "#1677ff" }} />
                                      <div style={{ marginTop: 4, fontSize: 11, color: "#8c8c8c" }}>
                                        {selected ? selected.name : (existingEmbroidary ? "Choose file to replace" : "Click or drag to upload")}
                                      </div>
                                    </div>
                                  </Upload.Dragger>
                                  {selected && (
                                    <Button
                                      type="text"
                                      danger
                                      size="small"
                                      icon={<DeleteOutlined />}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setEmbroidaryFilesBySide((prev) => {
                                          const newState = { ...prev };
                                          delete newState[label];
                                          return newState;
                                        });
                                        setEmbroidaryPreviewsBySide((prev) => {
                                          const next = { ...prev };
                                          delete next[label];
                                          return next;
                                        });
                                      }}
                                      style={{
                                        position: "absolute",
                                        top: 4,
                                        right: 4,
                                        padding: "2px 4px",
                                        minWidth: "auto",
                                        height: "auto",
                                      }}
                                    />
                                  )}
                                </div>
                                <Input
                                  size="small"
                                  placeholder="Title *"
                                  value={title}
                                  required
                                  onChange={(e) => setEmbroidaryTitlesBySide((prev) => ({ ...prev, [label]: e.target.value }))}
                                  status={selected && !title.trim() ? "error" : ""}
                                />
                                <Input.TextArea
                                  size="small"
                                  placeholder="Description *"
                                  value={description}
                                  required
                                  rows={2}
                                  onChange={(e) => setEmbroidaryDescriptionsBySide((prev) => ({ ...prev, [label]: e.target.value }))}
                                  status={selected && !description.trim() ? "error" : ""}
                                />
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                      <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
                        <Button
                          type="primary"
                          danger
                          size="middle"
                          loading={uploadImagesInfo.isLoading || updateImagesInfo.isLoading}
                          onClick={() => setShowRejectConfirmModal(true)}
                          disabled={Object.keys(embroidaryFilesBySide).length === 0}
                        >
                          Reject Jobcard
                        </Button>
                      </div>
                    </div>
                  )}
                </section>
              </div>
              {/* Notes (shown separately after images) */}
              {(() => {
                // Clean notes: hide auto-generated JSON keys like technique_map/eyelet_details
                const rawNotes = data?.notes;
                if (!rawNotes) return null;
                let cleaned = null;
                try {
                  const obj = JSON.parse(String(rawNotes));
                  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
                    const filtered = { ...obj };
                    // Support both lowercase and uppercase keys that might exist
                    delete filtered.technique_map;
                    delete filtered.eyelet_details;
                    delete filtered.TECHNIQUE_MAP;
                    delete filtered.EYELET_DETAILS;
                    // Only show notes if anything meaningful remains
                    if (Object.keys(filtered).length > 0) {
                      cleaned = JSON.stringify(filtered, null, 2);
                    } else {
                      cleaned = null;
                    }
                  } else {
                    cleaned = String(rawNotes);
                  }
                } catch (e) {
                  // Not JSON - show as plain text
                  cleaned = String(rawNotes);
                }
                if (!cleaned) return null;
                return (
                  <div className="print-hide" style={{ margin: "6px 0 0 110px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                      <div
                        style={{
                          width: 8,
                          height: 24,
                          background: "#1677ff",
                          borderRadius: 4
                        }}
                      />
                      <h1 className="style_info" style={{ margin: 0 }}>Notes</h1>
                    </div>
                    <div
                      style={{
                        background: "#fff",
                        borderRadius: 8,
                        padding: 14,
                        border: "1px solid #eaeaea",
                        whiteSpace: "pre-wrap",
                        color: "#333",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        maxWidth: "900px"
                      }}
                    >
                      {cleaned}
                    </div>
                  </div>
                );
              })()}
              {/* Main Image (shown after notes) */}
              {(() => {
                if (!canSeeImages) return null;
                const rawSrc = data?.main_image || data?.img1;
                if (!rawSrc) return null;
                const imageUrl = withBase(rawSrc);
                const lower = String(rawSrc || "").toLowerCase();
                const isPdf = lower.endsWith('.pdf');
                const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(lower);
                return (
                  <div className="print-hide" style={{ margin: "16px 0 0 50px" }}>
                    <div
                      style={{
                        background: "#fff",
                        borderRadius: 12,
                        padding: 20,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        marginBottom: 16,
                        width: "fit-content",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 16,
                          paddingBottom: 12,
                          borderBottom: "2px solid #f0f0f0",
                        }}
                      >
                        <div
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            background: "#722ed1",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontWeight: 700,
                          }}
                        >
                          M
                        </div>
                        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: "#333" }}>
                          Main Image
                        </h2>
                      </div>
                      <div
                        className="md-img-card"
                        style={{ position: "relative", width: 180, height: 180 }}
                      >
                        {imageUrl ? (
                          isPdf ? (
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <FilePdfOutlined style={{ fontSize: 48, color: "#cf1322" }} />
                            </div>
                          ) : isImage ? (
                            <img src={imageUrl} alt="Main Image" className="md-img" />
                          ) : (
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f7f7" }}>
                              <span role="img" aria-label="file" style={{ fontSize: 44, lineHeight: 1 }}>🗂️</span>
                            </div>
                          )
                        ) : (
                          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f7f7" }}>
                            <span role="img" aria-label="file" style={{ fontSize: 44, lineHeight: 1 }}>🗂️</span>
                          </div>
                        )}
                        <div className="md-overlay" />
                        <button
                          onClick={() => {
                            if (!imageUrl) return;
                            const withoutQuery = String(imageUrl).split('?')[0];
                            const dotIndex = withoutQuery.lastIndexOf('.');
                            const ext = dotIndex !== -1 ? withoutQuery.slice(dotIndex) : '';
                            downloadImage(imageUrl, `${data?.serial_number || data?.id || id}_Main${ext}`);
                          }}
                          style={{
                            position: "absolute",
                            bottom: 10,
                            left: "50%",
                            transform: "translateX(-50%)",
                            border: 0,
                            background: "#ffffff",
                            color: "#111",
                            cursor: "pointer",
                            fontSize: 16,
                            padding: "8px 12px",
                            borderRadius: 999,
                            fontWeight: 600,
                            zIndex: 2,
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          }}
                          className="md-download"
                        >
                          <DownloadOutlined />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })()}
              {/* Invoices (bottom, not part of print) */}
              {([ROLES.PAYMENT, ROLES.ACCOUNT, ROLES.DISPATCH].includes(role)) && (invoicesData || []).length ? (
                <div className="print-hide" style={{ margin: "16px 16px", padding: "1rem" }}>
                  <h1 className="style_info">Invoices</h1>
                  <div style={{
                    display: "flex",
                    gap: 12,
                    flexWrap: "wrap",
                  }}>
                    {(invoicesData || []).map((inv) => {
                      const lower = String(inv.original_name || inv.file || "").toLowerCase();
                      const isPdf = lower.endsWith('.pdf');
                      return (
                        <div key={inv.id} style={{
                          border: "1px solid #eee",
                          padding: 8,
                          borderRadius: 6,
                          background: "#fff",
                          width: 260,
                        }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{
                              width: 48,
                              height: 48,
                              borderRadius: 6,
                              background: "#fafafa",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}>
                              {isPdf ? (
                                <FilePdfOutlined style={{ fontSize: 28, color: "#cf1322" }} />
                              ) : (
                                <UploadOutlined style={{ fontSize: 24, color: "#8c8c8c" }} />
                              )}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontWeight: 500, fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={inv.original_name}>
                                {inv.original_name || `Invoice_${inv.id}`}
                              </div>
                              {inv.uploaded_by && (
                                <div style={{ fontSize: 11, color: '#888' }}>Uploaded by {inv.uploaded_by}</div>
                              )}
                            </div>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
                            <Tooltip title="Preview invoice">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPreviewInvoice(inv);
                                }}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  color: '#595959',
                                  cursor: 'pointer',
                                  fontSize: 16,
                                  padding: 0,
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                }}
                              >
                                <EyeOutlined />
                              </button>
                            </Tooltip>
                            <Tooltip title="Download invoice">
                              <button
                                onClick={() => {
                                  const url = inv.file;
                                  if (!url) return;
                                  const ext = isPdf ? '.pdf' : '';
                                  downloadS3File(url, `${data?.id || id}_Invoice_${inv.id}${ext}`, { neverOpenNewWindow: true });
                                }}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  color: '#1677ff',
                                  cursor: 'pointer',
                                  fontSize: 16,
                                  padding: 0,
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                }}
                              >
                                <DownloadOutlined />
                              </button>
                            </Tooltip>
                            {role === ROLES.ACCOUNT && (
                              <Tooltip title="Delete invoice">
                                <button
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    Modal.confirm({
                                      title: "Delete Invoice",
                                      content: `Are you sure you want to delete "${inv.original_name || `Invoice_${inv.id}`}"? This action cannot be undone.`,
                                      okText: "Delete",
                                      okType: "danger",
                                      cancelText: "Cancel",
                                      onOk: async () => {
                                        try {
                                          await deleteJobcardInvoice(inv.id).unwrap();
                                          message.success("Invoice deleted successfully");
                                          refetchInvoices();
                                        } catch (error) {
                                          message.error("Failed to delete invoice");
                                        }
                                      },
                                    });
                                  }}
                                  disabled={deleteInfo.isLoading}
                                  style={{
                                    border: 'none',
                                    background: 'transparent',
                                    color: '#ff4d4f',
                                    cursor: deleteInfo.isLoading ? 'not-allowed' : 'pointer',
                                    fontSize: 16,
                                    padding: 0,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    opacity: deleteInfo.isLoading ? 0.5 : 1,
                                  }}
                                >
                                  <DeleteOutlined />
                                </button>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : null}
              <Modal
                open={!!previewInvoice}
                title={previewInvoice ? `${previewInvoice.original_name || `Invoice_${previewInvoice.id}`}` : "Invoice Preview"}
                onCancel={() => setPreviewInvoice(null)}
                footer={[
                  <Button key="close" onClick={() => setPreviewInvoice(null)}>
                    Close
                  </Button>,
                  previewInvoice?.file ? (
                    <Button
                      key="download"
                      type="primary"
                      icon={<DownloadOutlined />}
                      onClick={() => {
                        const lower = String(previewInvoice?.original_name || previewInvoice?.file || "").toLowerCase();
                        const isPdf = lower.endsWith(".pdf");
                        const ext = isPdf ? ".pdf" : "";
                        downloadS3File(
                          previewInvoice.file,
                          `${data?.id || id}_Invoice_${previewInvoice.id}${ext}`,
                          { neverOpenNewWindow: true }
                        );
                      }}
                    >
                      Download
                    </Button>
                  ) : null,
                ].filter(Boolean)}
                width={900}
              >
                {previewInvoice ? (
                  (() => {
                    const url = previewInvoice.file;
                    const lower = String(previewInvoice.original_name || url || "").toLowerCase();
                    const isPdf = lower.endsWith(".pdf");
                    const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(lower);

                    if (!url) {
                      return <div>No preview available.</div>;
                    }

                    if (isPdf) {
                      return (
                        <iframe
                          src={`${url}#toolbar=1&navpanes=0&scrollbar=1`}
                          title="Invoice PDF"
                          style={{ width: "100%", height: "70vh", border: "none", borderRadius: 8, background: "#fff" }}
                        />
                      );
                    }

                    if (isImage) {
                      return (
                        <img
                          src={url}
                          alt={previewInvoice.original_name || "Invoice"}
                          style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 8 }}
                        />
                      );
                    }

                    return (
                      <div style={{ textAlign: "center", padding: "40px 0" }}>
                        <span role="img" aria-label="file" style={{ fontSize: 64, lineHeight: 1 }}>🗂️</span>
                        <div style={{ marginTop: 16 }}>Preview not available for this file type.</div>
                      </div>
                    );
                  })()
                ) : null}
              </Modal>
              {role === ROLES.ADMIN && (
                <Space className="print-hide">
                  <Button
                    type="primary"
                    style={{ margin: "1rem auto", display: "block" }}
                    onClick={async (e) => {
                      e.stopPropagation();

                      const isCreationDigitizerAssignAttempt = data?.current_stage === STAGES.CREATION &&
                        (data?.is_degitizer_stage === true || data?.is_degitizer_stage === "true") &&
                        (!data?.assigned_digitizers || data.assigned_digitizers.length === 0);

                      if (isCreationDigitizerAssignAttempt) {
                        navigate(`/jobcard/update/${data.id}`, { state: { autoFocusDigitizer: true } });
                        return;
                      }

                      // Frontend no longer validates "work done" before forwarding.
                      // Backend retains responsibility for any necessary validations.

                      // Continue with other existing validations (these will show modals if they fail)
                      // Backend will also validate all of these, so errors will be caught there too
                      const isPackingForwardAttempt =
                        role === ROLES.PACKING &&
                        data?.current_stage === STAGES.PACKING;

                      if (isPackingForwardAttempt && !courierMode) {
                        Modal.warning({
                          title: "Courier Mode Required",
                          content:
                            "Please select a courier mode before forwarding this jobcard to Billing.",
                        });
                        return;
                      }
                      const isBillingForwardAttempt =
                        role === ROLES.ACCOUNT &&
                        data?.current_stage === STAGES.ACCOUNT;

                      if (
                        isBillingForwardAttempt &&
                        (!Array.isArray(invoicesData) ||
                          invoicesData.length === 0)
                      ) {
                        Modal.warning({
                          title: "Invoice Required",
                          content:
                            "Please upload at least one invoice before forwarding this jobcard to Payment.",
                        });
                        return;
                      }

                      const nextStage = getNextStage(data.current_stage);

                      const updateData = {
                        id: data.id,
                        current_stage: nextStage,
                      };

                      // Backend now dynamically computes is_degitizer_stage when forwarding to cutting
                      // based on whether all required sides already have embroidery files attached.

                      // Call the mutation and wait for success, then redirect
                      // Backend will validate digitizer work completion for all versions when forwarding to embroidary
                      // Backend will validate courier mode for all versions when forwarding from packing
                      // Backend will validate invoices for all versions when forwarding from account
                      try {
                        await updateJobcard(updateData).unwrap();
                        // Invalidate all Card queries to refresh the table immediately
                        dispatch(allApi.util.invalidateTags(["Card", "Topcard"]));
                        // Redirect to jobcard page after successful forward
                        navigate("/");
                      } catch (error) {
                        // Check if error is about digitizer work remaining
                        if (error?.data?.error_code === "DIGITIZER_WORK_REMAINING") {
                          const incompleteVersions = error?.data?.incomplete_versions || [];
                          Modal.warning({
                            title: "Digitizer Work Remaining",
                            width: 600,
                            content: (
                              <div style={{ padding: "16px 0" }}>
                                <p style={{ fontSize: "16px", marginBottom: "16px", color: "#333", fontWeight: 500 }}>
                                  Digitizer's work is remaining for some job card versions. Please wait until the digitizer completes their work for all versions before forwarding to embroidary.
                                </p>
                                {incompleteVersions.length > 0 && (
                                  <div style={{ marginTop: "16px" }}>
                                    <strong style={{ display: "block", marginBottom: "8px" }}>Versions with remaining digitizer work:</strong>
                                    <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                      {incompleteVersions.map((version, index) => (
                                        <li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
                                          <span style={{ fontWeight: 500 }}>#{version.serial_number}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                                <p style={{ fontSize: "14px", color: "#666", marginTop: "16px", fontStyle: "italic" }}>
                                  All versions in a job card group must have completed digitizer work before forwarding to embroidary.
                                </p>
                              </div>
                            ),
                          });
                        } else if (error?.data?.error_code === "COURIER_MODE_REQUIRED") {
                          // Check if error is about courier mode missing
                          const incompleteVersions = error?.data?.incomplete_versions || [];
                          Modal.warning({
                            title: "Courier Mode Required",
                            width: 600,
                            content: (
                              <div style={{ padding: "16px 0" }}>
                                <p style={{ fontSize: "16px", marginBottom: "16px", color: "#333", fontWeight: 500 }}>
                                  Some job card versions do not have courier mode defined. Please define courier mode for all versions before forwarding from packing stage.
                                </p>
                                {incompleteVersions.length > 0 && (
                                  <div style={{ marginTop: "16px" }}>
                                    <strong style={{ display: "block", marginBottom: "8px" }}>Versions with missing courier mode:</strong>
                                    <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                      {incompleteVersions.map((version, index) => (
                                        <li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
                                          <span style={{ fontWeight: 500 }}>#{version.serial_number}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                                <p style={{ fontSize: "14px", color: "#666", marginTop: "16px", fontStyle: "italic" }}>
                                  All versions in a job card group must have courier mode defined before forwarding from packing stage.
                                </p>
                              </div>
                            ),
                          });
                        } else if (error?.data?.error_code === "INVOICE_REQUIRED") {
                          // Check if error is about invoices missing
                          const incompleteVersions = error?.data?.incomplete_versions || [];
                          Modal.warning({
                            title: "Invoice Required",
                            width: 600,
                            content: (
                              <div style={{ padding: "16px 0" }}>
                                <p style={{ fontSize: "16px", marginBottom: "16px", color: "#333", fontWeight: 500 }}>
                                  Some job card versions do not have invoices uploaded. Please upload at least one invoice for all versions before forwarding from account stage.
                                </p>
                                {incompleteVersions.length > 0 && (
                                  <div style={{ marginTop: "16px" }}>
                                    <strong style={{ display: "block", marginBottom: "8px" }}>Versions with missing invoices:</strong>
                                    <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                      {incompleteVersions.map((version, index) => (
                                        <li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
                                          <span style={{ fontWeight: 500 }}>#{version.serial_number}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                                <p style={{ fontSize: "14px", color: "#666", marginTop: "16px", fontStyle: "italic" }}>
                                  All versions in a job card group must have at least one invoice uploaded before forwarding from account stage.
                                </p>
                              </div>
                            ),
                          });
                        } else {
                          console.error("Failed to forward jobcard:", error);
                          Modal.error({
                            title: "Error",
                            content: error?.data?.detail || "Failed to forward job card",
                          });
                        }
                      }
                    }}
                    disabled={
                      data.current_stage === STAGES.COMPLETED ||
                      (data.current_stage !== STAGES.CREATION && role === ROLES.DESIGN)
                    }
                  >
                    {data.current_stage === STAGES.COMPLETED
                      ? "Completed"
                      : (data?.current_stage === STAGES.CREATION &&
                        (data?.is_degitizer_stage === true || data?.is_degitizer_stage === "true") &&
                        (!data?.assigned_digitizers || data.assigned_digitizers.length === 0))
                        ? "Assign Digitizer"
                        : `${data.current_stage === STAGES.DISPATCH
                          ? "Mark as"
                          : "Forward to"
                        }  ${getFormalName(getNextStage(data.current_stage))}`}
                  </Button>
                  <Button
                    type="primary"
                    style={{ margin: "1rem auto", display: "block" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      updateJobcard({
                        id: data.id,
                        current_stage: getPreviousStage(data.current_stage),
                      });
                      navigate("/");
                    }}
                    disabled={
                      data.current_stage === STAGES.CREATION ||
                      data.current_stage === STAGES.COMPLETED
                    }
                  >
                    {data.current_stage === STAGES.COMPLETED
                      ? "Completed"
                      : `Send back to ${getFormalName(
                        getPreviousStage(data.current_stage)
                      )}`}
                  </Button>
                </Space>
              )}

              {isDispatchDetailsLoading ? (
                <Loader />
              ) : dispatchDetails.length > 0 ? (
                <section style={{ marginTop: "1rem" }}>
                  <h1 className="style_info">Dispatch Details</h1>
                  <div
                    className="dispatch-details-grid"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                      gap: "12px",
                      width: "100%",
                    }}
                  >
                    {dispatchDetails.map((detail) => (
                      <Card
                        key={detail.id}
                        hoverable
                        style={{
                          borderRadius: 12,
                          borderColor: "#e2e8f0",
                          boxShadow: "0 6px 14px rgba(15,23,42,0.08)",
                          padding: 12,
                        }}
                        bodyStyle={{ padding: 0, display: "flex", flexDirection: "column", gap: 8 }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 4,
                          }}
                        >
                          <div style={{ fontWeight: 600, color: "#0f172a" }}>Recorded</div>
                          {detail.created_by && <Tag color="blue">{detail.created_by}</Tag>}
                        </div>
                        <div style={{ fontSize: 12, color: "#475569" }}>
                          {formatDateTimeDisplay(detail.created_at)}
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                          <div>
                            <div style={{ fontWeight: 600 }}>Delivery Date</div>
                            <div style={{ color: "#334155" }}>{formatDateDisplay(detail.delivery_date)}</div>
                          </div>
                          <div>
                            <div style={{ fontWeight: 600 }}>Time</div>
                            <div style={{ color: "#334155" }}>{formatTimeDisplay(detail.delivery_time)}</div>
                          </div>
                        </div>
                        <div>
                          <div style={{ fontWeight: 600 }}>Delivery Note</div>
                          <p style={{ marginTop: 2, color: "#334155", fontSize: 13 }}>
                            {detail.delivery_note || "—"}
                          </p>
                        </div>
                        {Array.isArray(detail.jobcards) && detail.jobcards.length > 0 && (
                          <div>
                            <div style={{ fontWeight: 600, marginBottom: 4 }}>Jobcards</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                              {detail.jobcards.map((jobcard) => (
                                <Tag key={`${detail.id}-${jobcard.id}`} color="geekblue">
                                  #{jobcard.serial_number || jobcard.id}
                                  {jobcard.client ? ` · ${jobcard.client}` : ""}
                                </Tag>
                              ))}
                            </div>
                          </div>
                        )}
                        {detail.delivery_acknowledgement_url && (
                          <div style={{ display: "flex", gap: 8 }}>
                            <Tooltip title="View acknowledgement">
                              <Button
                                size="small"
                                icon={<EyeOutlined />}
                                onClick={() =>
                                  setDispatchPreview({
                                    url: detail.delivery_acknowledgement_url,
                                    name: `Dispatch_Acknowledgement_${detail.id}`,
                                  })
                                }
                              />
                            </Tooltip>
                            <Tooltip title="Download acknowledgement">
                              <Button
                                size="small"
                                icon={<DownloadOutlined />}
                                onClick={() => {
                                  const url = detail.delivery_acknowledgement_url;
                                  if (!url) return;
                                  const base = url.split("?")[0] || "";
                                  const extMatch = base.match(/\.[0-9a-z]+$/i);
                                  const ext = extMatch ? extMatch[0] : "";
                                  downloadS3File(
                                    url,
                                    `${data?.id || id}_DispatchAck_${detail.id}${ext}`,
                                    { neverOpenNewWindow: true }
                                  );
                                }}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </Card>
                    ))}
                  </div>
                </section>
              ) : null}
            </MovieDetailSecondPgStyle>
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            width: "100%",
            maxWidth: "100%",
            marginBottom: "1rem",
            paddingTop: "1rem",
          }}
        >

          {canShowPackingSection && (
            <Form
              form={form}
              onFinish={async (values) => {
                // Validate carton boxes only if sizes are selected
                if (selectedCartonSizes.length > 0) {
                  const hasEmptyQuantity = selectedCartonSizes.some(
                    (size) => !cartonBoxes[size] || cartonBoxes[size] <= 0
                  );
                  if (hasEmptyQuantity) {
                    message.error("Please enter quantity for all selected box sizes");
                    return;
                  }
                }

                // Prepare carton boxes payload (always send, even if empty to allow clearing)
                const cartonBoxesData = selectedCartonSizes
                  .filter((size) => cartonBoxes[size] && cartonBoxes[size] > 0)
                  .map((size) => ({
                    size: parseInt(size),
                    quantity: parseInt(cartonBoxes[size]),
                  }));
                const cartonBoxesPayload = JSON.stringify(cartonBoxesData);

                try {
                  await updateJobcard({
                    id: data.id,
                    ...values,
                    carton_boxes: cartonBoxesPayload,
                    packing_note: packingNote || "",
                  }).unwrap();
                  message.success("Saved successfully");
                } catch (error) {
                  message.error("Failed to save changes");
                  console.error(error);
                }
              }}
              style={{
                padding: "1rem",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                width: "calc(100% - 80px)",
                maxWidth: "calc(100% - 80px)",
                margin: "24px auto",
                gap: "1rem",
              }}
            >
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <SelectType
                    label="Courier Mode"
                    name="courier_mode"
                    options={courierModeOptions}
                    value={setCourierMode}
                    style={{ width: "100%" }}
                  />
                  <Form.Item
                    label="Quantity"
                    name="quantity"
                    rules={[{ required: true, message: "Quantity is required!" }]}
                  >
                    <Input
                      type="number"
                      placeholder="Enter quantity"
                      onChange={(e) => setQuantity(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                  {courierMode && courierMode !== 'Self Pickup' && client && (
                    <>
                      <Form.Item label="Address Type">
                        <Radio.Group
                          value={addressType}
                          onChange={(e) => {
                            const value = e.target.value;
                            setAddressType(value);
                            const address = value === 'billing'
                              ? [
                                client.billing_address,
                                client.billing_city,
                                client.billing_state,
                                client.billing_country,
                                client.billing_pincode,
                              ].filter(Boolean).join(', ')
                              : [
                                client.shipping_address,
                                client.shipping_city,
                                client.shipping_state,
                                client.shipping_country,
                                client.shipping_pincode,
                              ].filter(Boolean).join(', ');
                            form.setFieldsValue({ shipping_address: address || '' });
                          }}
                        >
                          <Row gutter={16} style={{ marginTop: '16px' }}>
                            <Col span={12}>
                              <div
                                className={`address-card ${addressType === 'shipping' ? 'selected' : ''}`}
                                onClick={() => {
                                  setAddressType('shipping');
                                  const shippingAddress = [
                                    client.shipping_address,
                                    client.shipping_city,
                                    client.shipping_state,
                                    client.shipping_country,
                                    client.shipping_pincode,
                                  ].filter(Boolean).join(', ');
                                  form.setFieldsValue({ shipping_address: shippingAddress || '' });
                                }}
                                style={{
                                  border: addressType === 'shipping' ? '2px solid #1890ff' : '1px solid #d9d9d9',
                                  borderRadius: '8px',
                                  padding: '12px 14px',
                                  cursor: 'pointer',
                                  backgroundColor: addressType === 'shipping' ? '#f0f8ff' : '#fafafa',
                                  transition: 'all 0.3s ease',
                                  position: 'relative',
                                  minHeight: 120,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'space-between'
                                }}
                              >
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '8px',
                                  justifyContent: 'space-between'
                                }}>
                                  <h4 style={{ margin: 0, color: '#1890ff' }}>
                                    <Radio value="shipping">Shipping Address</Radio>
                                  </h4>
                                  {addressType === 'shipping' && (
                                    <div style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '50%',
                                      backgroundColor: '#1890ff',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}>
                                      <span style={{ color: 'white', fontSize: '12px' }}>✓</span>
                                    </div>
                                  )}
                                </div>
                                <div className="address-details">
                                  <p style={{ margin: 0, fontSize: '13px', lineHeight: '18px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                    {[
                                      client.shipping_address,
                                      client.shipping_city,
                                      client.shipping_state,
                                      client.shipping_country,
                                      client.shipping_pincode,
                                    ].filter(Boolean).join(', ') || 'Not provided'}
                                  </p>
                                </div>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div
                                className={`address-card ${addressType === 'billing' ? 'selected' : ''}`}
                                onClick={() => {
                                  setAddressType('billing');
                                  const billingAddress = [
                                    client.billing_address,
                                    client.billing_city,
                                    client.billing_state,
                                    client.billing_country,
                                    client.billing_pincode,
                                  ].filter(Boolean).join(', ');
                                  form.setFieldsValue({ shipping_address: billingAddress || '' });
                                }}
                                style={{
                                  border: addressType === 'billing' ? '2px solid #1890ff' : '1px solid #d9d9d9',
                                  borderRadius: '8px',
                                  padding: '12px 14px',
                                  cursor: 'pointer',
                                  backgroundColor: addressType === 'billing' ? '#f0f8ff' : '#fafafa',
                                  transition: 'all 0.3s ease',
                                  position: 'relative',
                                  minHeight: 120,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'space-between'
                                }}
                              >
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginBottom: '8px',
                                  justifyContent: 'space-between'
                                }}>
                                  <h4 style={{ margin: 0, color: '#1890ff' }}>
                                    <Radio value="billing">Billing Address</Radio>
                                  </h4>
                                  {addressType === 'billing' && (
                                    <div style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '50%',
                                      backgroundColor: '#1890ff',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}>
                                      <span style={{ color: 'white', fontSize: '12px' }}>✓</span>
                                    </div>
                                  )}
                                </div>
                                <div className="address-details">
                                  <p style={{ margin: 0, fontSize: '13px', lineHeight: '18px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                    {[
                                      client.billing_address,
                                      client.billing_city,
                                      client.billing_state,
                                      client.billing_country,
                                      client.billing_pincode,
                                    ].filter(Boolean).join(', ') || 'Not provided'}
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Radio.Group>
                      </Form.Item>
                      {courierMode && courierMode !== 'Self Pickup' && (
                        <Form.Item
                          label="Shipping Address"
                          name="shipping_address"
                          rules={[{ required: true, message: "Shipping address is required!" }]}
                        >
                          <Input.TextArea
                            rows={4}
                            placeholder="Enter or customize the shipping address"
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      )}
                      {courierMode === 'Courier' && (
                        <Form.Item
                          label="Courier Name"
                          name="courier_name"
                          rules={[{ required: true, message: "Courier name is required!" }]}
                        >
                          <Input
                            placeholder="Enter courier name"
                            value={courierName}
                            onChange={(e) => setCourierName(e.target.value)}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      )}
                    </>
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {canShowPackingSection && (
                    <>
                      <div style={{ marginBottom: "1rem" }} onClick={(e) => e.stopPropagation()}>
                        <div style={{ marginBottom: "12px", fontWeight: 500 }}>Carton Box Selection</div>
                        <div style={{ marginBottom: "8px", fontWeight: 500 }}>Select Box Sizes:</div>
                        <Checkbox.Group
                          value={selectedCartonSizes}
                          onChange={(checkedValues) => {
                            setSelectedCartonSizes(checkedValues);
                            const newBoxes = { ...cartonBoxes };
                            Object.keys(newBoxes).forEach((size) => {
                              if (!checkedValues.includes(parseInt(size))) {
                                delete newBoxes[size];
                              }
                            });
                            setCartonBoxes(newBoxes);
                          }}
                        >
                          <Row gutter={[16, 16]}>
                            {[5, 25, 50, 100, 150, 225, 300].map((size) => (
                              <Col key={size} span={8}>
                                <Checkbox
                                  value={size}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Size {size}
                                </Checkbox>
                              </Col>
                            ))}
                          </Row>
                        </Checkbox.Group>
                      </div>
                      {selectedCartonSizes.length > 0 && (
                        <div onClick={(e) => e.stopPropagation()}>
                          <div style={{ marginBottom: "12px", fontWeight: 500 }}>Enter Quantities:</div>
                          <Row gutter={[16, 16]}>
                            {selectedCartonSizes.map((size) => (
                              <Col key={size} span={12}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <span style={{ minWidth: "80px" }}>Size {size}:</span>
                                  <Input
                                    type="number"
                                    min={1}
                                    placeholder="Quantity"
                                    value={cartonBoxes[size] || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setCartonBoxes({
                                        ...cartonBoxes,
                                        [size]: value ? parseInt(value) : "",
                                      });
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    onMouseDown={(e) => e.stopPropagation()}
                                    onFocus={(e) => e.stopPropagation()}
                                    style={{ flex: 1 }}
                                  />
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      )}
                      <div style={{ marginTop: "24px" }} onClick={(e) => e.stopPropagation()}>
                        <div style={{ marginBottom: "8px", fontWeight: 500 }}>Packing Note:</div>
                        <Input.TextArea
                          rows={4}
                          placeholder="Enter packing note..."
                          value={packingNote}
                          onChange={(e) => setPackingNote(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          onFocus={(e) => e.stopPropagation()}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </>
                  )}
                </Col>
              </Row>
              <Form.Item style={{ marginTop: 16 }}>
                <Button type="primary" htmlType="submit" loading={isUpdating} style={{ marginTop: 8 }}>
                  Save
                </Button>
              </Form.Item>
            </Form>
          )}

          <div style={{
            position: "relative",
            width: "100%",
            marginBottom: "1rem",
            marginTop: "1rem",
            minHeight: 36,
          }}>
            {role === ROLES.ACCOUNT ? (
              <>
                {/* Left side: Upload Invoice PDF */}
                <div
                  className="print-hide"
                  style={{
                    position: "absolute",
                    left: "30px",
                    top: "-20px",
                    maxWidth: "500px",
                  }}
                >
                  <Form
                    onFinish={async () => {
                      if (!uploadFiles || uploadFiles.length === 0) {
                        message.warning("Please select at least one file to upload");
                        return;
                      }
                      try {
                        const filesPayload = uploadFiles
                          .map((f) => f.originFileObj || f)
                          .filter(Boolean);
                        await uploadJobcardInvoices({
                          job_card_id: data?.id || id,
                          files: filesPayload,
                        }).unwrap();
                        message.success("Files uploaded successfully");
                        setUploadFiles([]);
                        // Refetch invoices data
                        refetchInvoices();
                      } catch (e) {
                        message.error("Failed to upload files");
                      }
                    }}
                  >
                    <div style={{
                      border: "1px dashed #d9d9d9",
                      borderRadius: 8,
                      padding: 4,
                      background: "#fafafa",
                      minHeight: 40,
                    }}>
                      <Upload.Dragger
                        multiple
                        beforeUpload={() => false}
                        fileList={uploadFiles}
                        onChange={({ fileList }) => {
                          setUploadFiles(fileList);
                        }}
                        accept={"*"}
                        showUploadList={true}
                        style={{ minHeight: 26, padding: "2px 0" }}
                      >
                        <p className="ant-upload-drag-icon" style={{ marginBottom: 0, fontWeight: 500, color: "#1677ff", display: "flex", alignItems: "center", justifyContent: "center", gap: 4, fontSize: 11, lineHeight: 1.2 }}>
                          <UploadOutlined style={{ fontSize: 14 }} /> Upload Invoice PDF
                        </p>
                      </Upload.Dragger>

                      <Form.Item style={{ marginTop: 6, marginBottom: 0 }}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={uploadInfo.isLoading}
                          disabled={!uploadFiles || uploadFiles.length === 0}
                          size="small"
                          style={{ padding: "4px 12px" }}
                        >
                          Upload Files
                        </Button>
                      </Form.Item>

                      {(invoicesData || []).length > 0 && (
                        <div
                          style={{
                            marginTop: 8,
                            background: "#fff",
                            border: "1px solid #eee",
                            borderRadius: 6,
                            padding: 8,
                            maxHeight: 160,
                            overflowY: "auto",
                          }}
                          className="print-hide"
                        >
                          <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 6 }}>
                            Previously uploaded
                          </div>
                          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            {(invoicesData || []).map((inv) => {
                              const lower = String(inv.original_name || inv.file || "").toLowerCase();
                              const isPdf = lower.endsWith(".pdf");
                              return (
                                <div
                                  key={inv.id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                  }}
                                >
                                  <span
                                    style={{
                                      width: 28,
                                      height: 28,
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: 4,
                                      background: "#fafafa",
                                      flex: "0 0 auto",
                                    }}
                                  >
                                    {isPdf ? (
                                      <FilePdfOutlined style={{ fontSize: 18, color: "#cf1322" }} />
                                    ) : (
                                      <UploadOutlined style={{ fontSize: 16, color: "#8c8c8c" }} />
                                    )}
                                  </span>
                                  <span
                                    title={inv.original_name}
                                    style={{
                                      fontSize: 12,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      minWidth: 0,
                                    }}
                                  >
                                    {inv.original_name || `Invoice_${inv.id}`}
                                  </span>
                                  <div style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                                    <Tooltip title="Preview invoice">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setPreviewInvoice(inv);
                                        }}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          color: "#595959",
                                          cursor: "pointer",
                                          fontSize: 14,
                                          padding: 0,
                                          display: "inline-flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <EyeOutlined />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Download invoice">
                                      <button
                                        onClick={() => {
                                          const url = inv.file;
                                          if (!url) return;
                                          const ext = isPdf ? ".pdf" : "";
                                          downloadS3File(
                                            url,
                                            `${data?.id || id}_Invoice_${inv.id}${ext}`,
                                            { neverOpenNewWindow: true }
                                          );
                                        }}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          color: "#1677ff",
                                          cursor: "pointer",
                                          fontSize: 14,
                                          padding: 0,
                                          display: "inline-flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete invoice">
                                      <button
                                        onClick={async (e) => {
                                          e.stopPropagation();
                                          Modal.confirm({
                                            title: "Delete Invoice",
                                            content: `Are you sure you want to delete "${inv.original_name || `Invoice_${inv.id}`}"? This action cannot be undone.`,
                                            okText: "Delete",
                                            okType: "danger",
                                            cancelText: "Cancel",
                                            onOk: async () => {
                                              try {
                                                await deleteJobcardInvoice(inv.id).unwrap();
                                                message.success("Invoice deleted successfully");
                                                refetchInvoices();
                                              } catch (error) {
                                                message.error("Failed to delete invoice");
                                              }
                                            },
                                          });
                                        }}
                                        disabled={deleteInfo.isLoading}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          color: "#ff4d4f",
                                          cursor: deleteInfo.isLoading ? "not-allowed" : "pointer",
                                          fontSize: 14,
                                          padding: 0,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          opacity: deleteInfo.isLoading ? 0.5 : 1,
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </Form>
                </div>
                {/* Right side: Print Out button */}
                <button
                  style={{
                    textAlign: "center",
                    background: "var(--color-primary)",
                    color: "var(--light)",
                    padding: ".5rem 1rem",
                    border: "none",
                    borderRadius: ".2rem",
                    fontWeight: "500",
                    position: "absolute",
                    right: 200,
                  }}
                  onClick={handlePrint}
                >
                  Print Out
                </button>
              </>
            ) : (
              role === ROLES.PAYMENT ? (
                <button
                  style={{
                    textAlign: "center",
                    background: "var(--color-primary)",
                    color: "var(--light)",
                    padding: ".5rem 1rem",
                    border: "none",
                    borderRadius: ".2rem",
                    fontWeight: "500",
                    position: "absolute",
                    right: "200px",
                    top: 0,
                  }}
                  onClick={handlePrint}
                >
                  Print Out
                </button>
              ) : (
                <button
                  style={{
                    textAlign: "center",
                    background: "var(--color-primary)",
                    color: "var(--light)",
                    padding: ".5rem 1rem",
                    border: "none",
                    borderRadius: ".2rem",
                    fontWeight: "500",
                    position: "absolute",
                    transform: "translateX(-50%)",
                  }}
                  onClick={handlePrint}
                >
                  Print Out
                </button>
              )
            )}
            {role === ROLES.PAYMENT && (
              <div style={{
                position: "absolute",
                left: "30px",
                top: 0,
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                whiteSpace: "nowrap",
              }}>
                <label style={{ fontWeight: "500" }}>
                  Payment Status:
                </label>
                <Select
                  value={data?.status || "pending"}
                  style={{
                    width: '240px',
                    borderColor: getStatusColor(data?.status || "pending").border,
                    backgroundColor: getStatusColor(data?.status || "pending").background,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderRadius: '4px',
                  }}
                  onChange={async (newStatus) => {
                    try {
                      await updateJobcard({
                        id: data.id,
                        status: newStatus,
                      }).unwrap();
                      message.success(`Payment status updated to ${formatStatus(newStatus)}`);
                    } catch (error) {
                      message.error('Failed to update payment status');
                    }
                  }}
                  options={PAYMENT_STATUS_OPTIONS.map(option => ({
                    ...option,
                    label: (
                      <span style={{ fontWeight: 500 }}>
                        {option.label}
                      </span>
                    ),
                  }))}
                />
              </div>
            )}
          </div>
          {role === ROLES.PAYMENT && (
            <div className="print-hide" style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              justifyContent: 'center',
              marginTop: 8,
            }}>

            </div>
          )}
        </div>
      </div>
      {/* Digitizer Work Validation Modal */}
      <Modal
        title="Digitizer Work Remaining"
        open={showDigitizerValidationModal}
        onOk={() => setShowDigitizerValidationModal(false)}
        onCancel={() => setShowDigitizerValidationModal(false)}
        okText="OK"
        cancelButtonProps={{ style: { display: 'none' } }}
        width={500}
      >
        <div style={{ padding: "16px 0" }}>
          <p style={{ fontSize: "16px", marginBottom: "12px", color: "#333" }}>
            Digitizer's work is remaining. Please wait until the digitizer completes their work before forwarding to embroidary.
          </p>
          <p style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
            Once the digitizer marks the work as done, you will be able to forward this job card to embroidary.
          </p>
        </div>
      </Modal>

      {/* Reject Jobcard Confirmation Modal */}
      <Modal
        title={`Reject Jobcard #${data?.serial_number || data?.id || ""}?`}
        open={showRejectConfirmModal}
        onCancel={() => setShowRejectConfirmModal(false)}
        confirmLoading={uploadImagesInfo.isLoading || updateImagesInfo.isLoading || isUpdating}
        onOk={async () => {
          setShowRejectConfirmModal(false);
          await handleEmbroidaryUpload();
        }}
        okText="Yes, Reject Jobcard"
        okButtonProps={{ danger: true }}
        cancelText="Cancel"
        width={500}
      >
        <div style={{ padding: "16px 0" }}>
          <p style={{ fontSize: "16px", marginBottom: "12px", color: "#333" }}>
            Are you sure you want to reject this jobcard?
          </p>
          <p style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
            This will upload the rejection images with titles and descriptions, and send the jobcard back to the digitizer stage. The jobcard will be removed from embroidary and sent back to cutting stage.
          </p>
        </div>
      </Modal>

      <Modal
        open={!!dispatchPreview}
        title={dispatchPreview ? dispatchPreview.name : "Dispatch Acknowledgement"}
        onCancel={() => setDispatchPreview(null)}
        footer={[
          <Button key="close" onClick={() => setDispatchPreview(null)}>
            Close
          </Button>,
          dispatchPreview?.url ? (
            <Button
              key="download"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => {
                const url = dispatchPreview.url;
                const base = url.split("?")[0] || "";
                const extMatch = base.match(/\.[0-9a-z]+$/i);
                const ext = extMatch ? extMatch[0] : "";
                downloadS3File(url, `${dispatchPreview.name}${ext}`, {
                  neverOpenNewWindow: true,
                });
              }}
            >
              Download
            </Button>
          ) : null,
        ].filter(Boolean)}
        width={700}
      >
        {dispatchPreview ? (
          (() => {
            const url = dispatchPreview.url;
            const lower = String(url || "").toLowerCase();
            const isPdf = lower.endsWith(".pdf");
            const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(lower);

            if (!url) {
              return <div>No preview available.</div>;
            }

            if (isPdf) {
              return (
                <iframe
                  src={`${url}#toolbar=1&navpanes=0&scrollbar=1`}
                  title="Dispatch Acknowledgement"
                  style={{ width: "100%", height: "70vh", border: "none", borderRadius: 8, background: "#fff" }}
                />
              );
            }

            if (isImage) {
              return (
                <img
                  src={url}
                  alt={dispatchPreview.name || "Dispatch Acknowledgement"}
                  style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 8 }}
                />
              );
            }

            return (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <span role="img" aria-label="file" style={{ fontSize: 64, lineHeight: 1 }}>🗂️</span>
                <div style={{ marginTop: 16 }}>Preview not available for this file type.</div>
              </div>
            );
          })()
        ) : null}
      </Modal>
    </>
  ) : (
    <Loader />
  );
};

export default MovieDetail;
